import { jsx, css } from '@emotion/react';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import Card from '../oc-card';
import RichText from '../oc-rich-text';
import VideoCard from '../oc-video-card';

const styles = css`
  .oc-gallery {
    display: flex;
    flex-dirextion: row;
    flex-wrap: wrap;

    .oc-video-card,
    .oc-card {
      width: 22%;
      position: relative;
      margin-right: 4%;

      .media,
      .video {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 197px;
      }

      .text {
        height: 57px;

        p {
          margin: 15px 0;
        }
      }

      &:nth-of-type(4n) {
        margin-right: 0;
      }

      @media (max-width: 1199px) {
        width: 46%;
        margin-right: 8%;

        &:nth-of-type(2n) {
          margin-right: 0;
        }
      }

      @media (max-width: 767px) {
        width: 100%;
        margin-right: 0;

        .media,
        .video {
          height: auto;
        }

        .text {
          height: auto;
        }
      }
    }
  }
`;

const Resources = connectLocation(({ t, resources, heading, anchor, className }) => (
  <Section css={styles} anchor={anchor} className={className}>
    <h2>
      <RichText content={heading} />
    </h2>
    <div className="oc-gallery">
      {resources.map(({ id, proper_name, caption, alt, url, thumb = {}, duration }) =>
        duration ? (
          <VideoCard key={id} img={thumb.url} url={url} alt={proper_name} className="resource">
            <p>
              <RichText content={proper_name} />
            </p>
          </VideoCard>
        ) : (
          <Card key={id} addModal img={url} alt={alt} className="resource">
            <p>
              <RichText content={caption} />
            </p>
          </Card>
        )
      )}
    </div>
  </Section>
));

Resources.WrappedComponent.displayName = 'Resources';

export default Resources;
